export enum RealEstateValuationTypeEnum {
  ValuationReportNwwi = 'ValuationReportNwwi',
  WozDecision = 'WozDecision',
  CalcasaDesktopStatement = 'CalcasaDesktopStatement',
}
